import * as React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Slide,
} from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions';

const Transition = React.forwardRef(
    (
        props: TransitionProps & { children?: React.ReactElement<any, any> },
        ref: React.Ref<unknown>
    ) => <Slide direction='up' ref={ref} {...props} />
);

interface IProps {
    open: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

export const ConfirmLogin = (props: IProps) => {
    return (
        <Dialog
            open={props.open}
            TransitionComponent={Transition}
            keepMounted
            onClose={props.onClose}
            aria-labelledby='alert-dialog-slide-title'
            aria-describedby='alert-dialog-slide-description'
        >
            <DialogContent>
                <DialogContentText id='alert-dialog-slide-description'>
                Someone is already logged in using this account. You can continue to log in but we will
                automatically log the other person out
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onConfirm} color='primary'>
                    Force Login
                </Button>
                <Button onClick={props.onClose} color='secondary'>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};
